import React, { useEffect, useRef, useState } from 'react';
import '../../i18n';
import { useTranslation } from 'react-i18next';
import { FaGlobe, FaChevronDown } from 'react-icons/fa';
import '../../styles/LanguageSwitcher.scss';

const languages = [
  { code: 'en', label: 'English', short: 'EN' },
  { code: 'fi', label: 'Suomi',   short: 'FI' },
  // { code: 'sv', label: 'Svenska', short: 'SV' },
];

function LanguageSelector() {
  const { i18n } = useTranslation();
  const [selectedLanguage, setSelectedLanguage] = useState(i18n.language);
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const saved = localStorage.getItem('selectedLanguage') || navigator.language.slice(0, 2);
    const defaultLang = languages.some(l => l.code === saved) ? saved : 'en';
    i18n.changeLanguage(defaultLang);
    setSelectedLanguage(defaultLang);
  }, [i18n]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  function selectLang(code) {
    i18n.changeLanguage(code);
    localStorage.setItem('selectedLanguage', code);
    setSelectedLanguage(code);
    setOpen(false);
  }

  const current = languages.find(l => l.code === selectedLanguage) ?? languages[0];

  return (
    <div className="lang-switcher" ref={ref}>
      <button className={`lang-trigger${open ? ' lang-trigger--open' : ''}`} onClick={() => setOpen(o => !o)}>
        <FaGlobe size={13} />
        <span className="lang-trigger-label">{current.short}</span>
        <FaChevronDown size={9} className="lang-chevron" />
      </button>

      <div className={`lang-dropdown${open ? ' lang-dropdown--open' : ''}`}>
        {languages.map(lang => (
          <button
            key={lang.code}
            className={`lang-option${lang.code === selectedLanguage ? ' lang-option--active' : ''}`}
            onClick={() => selectLang(lang.code)}>
            {lang.short}
          </button>
        ))}
      </div>
    </div>
  );
}

export default LanguageSelector;
